import React from 'react';
import { Outlet } from 'react-router-dom';
import { Layout } from 'antd';
import { GithubOutlined } from '@ant-design/icons';

import './unauthenticated.css';

const { Footer } = Layout;

export const UnauthenticatedLayout: React.FC = () => {
    return (
        <Layout className="unauthenticated-layout container">
            <div className="content">
                <Outlet />
            </div>

            <Footer className="footer">
                <a 
                    href="https://github.com/pwrtls/tools" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="github-link"
                >
                    <GithubOutlined /> Contribute to Power Tools
                </a>
            </Footer>
        </Layout>
    );
}
